export const TRANSLATION = 'translation';